import { Content, DefaultPage } from '@shared/layout/DefaultPage'
import { PremiumExerciseFooter } from '@widgets/exercise/ExerciseFooter'
import { AIRecommendations } from '@widgets/exercise/AIRecommendations'
import { VideoInfoStore } from '@entities/VideoCaptureStore'
import { UploadVideo } from '@features/exercise/UploadVideo'
import { observer } from 'mobx-react'
import { VideoFromFrames } from '@features/exercise/AIVideo'
import { ResultFrame } from '@entities/Frame'
import { useLocation } from 'react-router-dom'
import { BackArrowHeader } from '@widgets/BackArrowHeader'
import { useGoBack } from '@shared/hooks/UseGoBack'
import { Heading } from '@ui/Heading'
import { useIonRouter } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'

export const CheckExercisePage = observer(() => {
	const videoInfoStore: VideoInfoStore = VideoInfoStore.instance
	const frames: { frame: string; frameData: ResultFrame }[] = videoInfoStore.framesToShow.slice(0)
	const location = useLocation()
	const queryParams: URLSearchParams = new URLSearchParams(location.search)
	const title: string | null = queryParams.get('title')
	const backPath: string | null = queryParams.get('backPath')
	const nav = useIonRouter()
	// const goBack = useGoBack()

	const goBack = () => {
		console.log('backPath', backPath)
		// if (backPath) {
		// 	nav.push(backPath)
		// }
		if (nav.canGoBack()) {
			nav.goBack()
		} else {
			nav.push(ROUTES.overall.main)
		}
	}

	if (!title) {
		goBack()
	}

	return (
		<DefaultPage>
			<Content key={window.location.href}>
				<BackArrowHeader
					centeredChildren
					goBackFunction={() => {
						videoInfoStore.isVideoLoading = false
						videoInfoStore.isCaptured = false
						videoInfoStore.reset()
						goBack()
					}}>
					<Heading>{title}</Heading>
				</BackArrowHeader>
				{videoInfoStore.isCaptured && (
					<VideoFromFrames frames={frames} style={{ marginTop: 10 }} />
				)}
				{!videoInfoStore.isCaptured && <UploadVideo style={{ marginTop: 10 }} />}
				<AIRecommendations />
			</Content>
			<PremiumExerciseFooter />
		</DefaultPage>
	)
})
